import React from "react";
import { Container } from "react-bootstrap";
import Link from "next/link";
import Logo from "../../../images/Logo.svg";
import * as s from "./index.module.scss";
import { IoMenu } from "react-icons/io5";
import { useRouter } from "next/router";
import Image from "next/image";
import NavigationItems from "./components/NavigationItems";

const Layout = ({ toggle, setToggle, expanded, setExpanded }) => {
  const { asPath } = useRouter();

  return (
    <header className={`${s.navbar}`}>
      <Container>
        <div className="d-flex justify-content-between align-items-center">
          <div
            className="navbar-brand"
            onClick={() => {
              setExpanded(false);
            }}
          >
            <Link href={"/"}>
              <Image
                loading="eager"
                src={Logo.src}
                alt="image"
                className="h-100 w-100"
                width={200}
                height={200}
              />
            </Link>
          </div>
          <button
            aria-label="menu icon"
            className={`navbar-toggler ${s.navbar_toggler} pt-0`}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            <IoMenu size="40px" />
          </button>
          <div className={`${s.desktop_nav_container}`}>
            <NavigationItems
              expanded={expanded}
              setExpanded={setExpanded}
              setToggle={setToggle}
              toggle={toggle}
            />
          </div>
        </div>
      </Container>
      <div
        className={`${s.mobile_nav_container} ${expanded ? s.show_nav : ""}`}
      >
        <NavigationItems
          expanded={expanded}
          setExpanded={setExpanded}
          setToggle={setToggle}
          toggle={toggle}
        />
      </div>
    </header>
  );
};

export default Layout;
